const ja = {
  "common.cancel": "キャンセル",
  "common.close": "閉じる",
  "common.on": "オン",
  "common.off": "オフ",
  "common.show": "表示",
  "common.hide": "非表示",
  "common.hint": "ヒント",
  "common.showHint": "ヒントを表示",
  "common.labelCountShowHint": "{label} {count}。ヒントを表示",

  "duration.minutes_other": "{count}分",
  "duration.hours_other": "{count}時間",

  "splash.description":
    "Aeterna Invictaは、Magic: The GatheringとPath of Exileの最も面白い要素を融合させたトレーディングカードゲームを目指しています。デッキを組み、シナジーを見つけ、カードを上手く使って対戦相手に打ち勝ちましょう。",
  "splash.tagline": "永遠にして無敵の存在となれ！",
  "splash.tutorials": "初めての方はこちら：チュートリアル",
  "splash.enterGame": "ゲーム開始",

  "nav.collapse": "ナビゲーションを折りたたむ",
  "nav.expand": "ナビゲーションを展開",
  "nav.summary": "結果",
  "nav.game": "対戦",
  "nav.queue": "マッチング",
  "nav.decks": "デッキ",
  "nav.library": "ライブラリ",
  "nav.achievements": "デイリーと実績",
  "nav.customize": "カスタマイズ",
  "nav.marketplace": "マーケット",
  "nav.social": "ソーシャル",
  "nav.ranking": "ランキング",
  "nav.settings": "設定",
  "nav.workshop": "ワークショップ",
  "nav.community": "コミュニティ",
  "nav.support": "サポート",

  "hud.gameLog": "ゲームログ",
  "hud.patchNotes": "パッチノート",
  "hud.showNavbar": "ナビを表示",
  "hud.hideNavbar": "ナビを隠す",
  "hud.queued": "マッチング中",
  "hud.forfeit": "降参",
  "hud.leave": "退出",
  "hud.leaveSpectate": "観戦をやめる",
  "hud.serverMessages": "サーバーメッセージ",
  "hud.serverMessagesNew": "サーバーメッセージ（新着）",

  "serverMessages.title": "サーバーメッセージ",
  "serverMessages.kindAdmin": "サーバーメッセージ",
  "serverMessages.kindMaintenance": "サーバーメンテナンス",
  "serverMessages.inProgress":
    "サーバーメンテナンス中です。サーバーはいつでも再起動する可能性があります。",
  "serverMessages.beginsIn": "サーバーメンテナンス開始まで",
  "serverMessages.empty": "現在、サーバーメッセージはありません。",
  "serverMessages.view": "サーバーメッセージを見る",
  "serverMessages.template.patchApplied":
    "新しいパッチが配信されました。最新バージョンを読み込むには、ページを更新するかアプリを再起動してください。",
  "serverMessages.template.maintenanceComplete":
    "サーバーメンテナンスが完了しました。ご協力ありがとうございました！",
  "serverMessages.template.restartingNow":
    "サーバーを再起動しています。まもなく自動的に再接続されます。",
  "serverMessages.template.maintenanceExtended":
    "サーバーメンテナンスが予定より長引いています。まもなく再開いたします。",
  "serverMessages.template.investigatingIssue":
    "現在、問題を確認し調査しています。しばらくお待ちください。",
  "serverMessages.template.reportBugs":
    "Aeterna Invictaをプレイしていただきありがとうございます！不具合はサポートページからご報告ください。",
  "serverMessages.template.maintenanceCountdown":
    "サーバーメンテナンスは{duration}後に開始します。それまでに対戦を終えてください。",
  "serverMessages.template.maintenanceStarting":
    "サーバーメンテナンスを開始します。サーバーはいつでも再起動する可能性があります。",
  "serverMessages.template.maintenanceCancelled":
    "予定されていたサーバーメンテナンスは中止されました。",

  "completion.achievement": "実績達成",
  "completion.daily": "デイリー達成",

  "settings.title": "設定",
  "settings.backToMenu": "設定に戻る",
  "settings.section.account": "アカウント",
  "settings.section.general": "一般",
  "settings.section.gameplay": "ゲームプレイ",
  "settings.section.display": "表示",
  "settings.section.controls": "操作とアクセシビリティ",
  "settings.section.social": "ソーシャルとプライバシー",
  "settings.section.danger": "危険な操作",
  "settings.musicVolume.label": "音楽の音量",
  "settings.soundVolume.label": "効果音の音量",
  "settings.volume.decrease": "{label}を下げる",
  "settings.volume.increase": "{label}を上げる",
  "settings.volume.description": "この端末に保存されます。",

  "settings.language.label": "言語",
  "settings.language.description":
    "メニューとメッセージの表示言語を選択します。カード名とカードテキストは英語のままです。",

  "settings.account.label": "アカウント",
  "settings.account.guestSuffix": "（ゲスト）",
  "settings.account.guestDescription":
    "ゲストの進行状況は最大24時間保持されます。ログアウトするとこのゲストデータは完全に削除されます。",
  "settings.account.savedDescription":
    "この端末で登録済みアカウントにサインインしています。",
  "settings.account.createAndKeep": "アカウントを作成して進行状況を引き継ぐ",
  "settings.account.migratePrompt":
    "アカウントを作成し、現在の進行状況をそのアカウントへ移行します。",
  "settings.account.username": "ユーザー名",
  "settings.account.password": "パスワード",
  "settings.account.migrating": "移行中…",
  "settings.account.createAccount": "アカウント作成",
  "settings.account.changePasswordPrompt": "パスワードを変更します。",
  "settings.account.currentPassword": "現在のパスワード",
  "settings.account.newPassword": "新しいパスワード",
  "settings.account.confirmNewPassword": "新しいパスワード（確認）",
  "settings.account.saving": "保存中…",
  "settings.account.updatePassword": "パスワードを更新",
  "settings.account.changePassword": "パスワード変更",
  "settings.account.logOut": "ログアウト",
  "settings.account.logOutGuestConfirm":
    "ログアウトして、このゲストアカウントとすべての進行状況を完全に削除しますか？",
  "settings.account.logOutConfirm": "この端末でこのアカウントからログアウトしますか？",
  "settings.account.confirmLogOut": "ログアウトする",

  "settings.music.label": "音楽",
  "settings.music.description":
    "BGMを再生します。メニューと対戦の曲は別々のプレイリストで、シャッフル再生され、対戦の開始時や終了時もクロスフェードします。",

  "settings.sound.label": "効果音",
  "settings.sound.description":
    "ドローなどの対戦中のイベントで効果音を再生します。",
  "settings.sound.skipTrack": "次の曲へスキップ",

  "settings.workshop.label": "ワークショップ",
  "settings.workshop.description":
    "ナビゲーションバーのワークショップボタンを表示または非表示にします。",

  "settings.quickUse.label": "クイック使用を表示",
  "settings.quickUse.description":
    "リソースや攻撃のためのクイック消費ボタンの表示を切り替えます。質より効率を重視して、装備やアビリティを素早く使いたいときに便利です。",

  "settings.hints.label": "ヒント",
  "settings.hints.description":
    "対戦中の状況に応じたヒントボタンを切り替えます。？アイコンをタップすると、近くのUIの説明が表示されます。",

  "settings.matchGuides.label": "対戦ガイド",
  "settings.matchGuides.auto": "自動",
  "settings.matchGuides.description":
    "CPUやプレイヤーとの対戦中に、プレイできるカード、使える装備とアビリティ、ターン終了ボタンを光らせ、折りたためるヘルプボックスを表示します。自動ではゲストアカウントと最初の{games}試合でガイドを表示します。",
  "settings.cardNames.label": "カード名",
  "settings.cardNames.description":
    "手札のカードと装備スロットに置かれたカードの名前を表示または非表示にします。",

  "settings.leftHanded.label": "左手モード",
  "settings.leftHanded.description":
    "対戦中、ターン終了ボタンとエモートボタンを左側に、手札を右側に配置します。",

  "settings.theme.label": "テーマ",
  "settings.theme.dark": "ダーク",
  "settings.theme.light": "ライト",
  "settings.theme.description": "テーマを切り替えます。",

  "settings.graphics.label": "グラフィック品質",
  "settings.graphics.auto": "自動",
  "settings.graphics.high": "高",
  "settings.graphics.medium": "中",
  "settings.graphics.low": "低",
  "settings.graphics.description":
    "品質を下げると、背景の動き、フォイルのアニメーション、発光、ぼかしを抑えて、性能の低い端末でも対戦を滑らかにします。自動ではこの端末に合わせて品質を選び、対戦がカクつく場合は品質を下げます。端末ごとに保存されます。",
  "settings.graphics.autoCurrent": "現在の品質：{tier}。",
  "settings.graphics.autoLowered":
    "対戦を滑らかにするため、グラフィック品質を{tier}に下げました。設定から変更できます。",

  "settings.foil.label": "フォイル効果",
  "settings.foil.minimum": "最小",
  "settings.foil.maximum": "最大",
  "settings.foil.description":
    "最大では、デッキビルダー・対戦・結果画面でフォイルの光沢がアニメーションします。コレクションやライブラリなどの密集したグリッドは静止したままです。最小ではすべての場所でフォイルの見た目が静止します。オフではグレースケールや別色などの静的な色の処理のみが残ります。",

  "settings.toasts.label": "トースト通知",
  "settings.toasts.cardOnly": "カードのみ",
  "settings.toasts.textOnly": "テキストのみ",
  "settings.toasts.all": "すべて",
  "settings.toasts.description":
    "表示する対戦やアクションのポップアップを選択します。オフはすべて非表示、カードのみは小さなカードプレビュー、テキストのみはメッセージ通知、すべては両方を表示します。",

  "settings.toastSpeed.label": "トースト速度",
  "settings.toastSpeed.fast": "速い",
  "settings.toastSpeed.standard": "標準",
  "settings.toastSpeed.description":
    "速いでは通知を短く表示してからフェードアウトします。標準では通常の時間表示されます。タップまたはクリックでいつでも閉じられます。",
  "settings.handDisplay.label": "手札の表示",
  "settings.handDisplay.drawer": "ドロワー",
  "settings.handDisplay.dynamic": "ダイナミック",
  "settings.handDisplay.description":
    "ドロワーでは手札を常に全体表示し、横の矢印でカード名だけが見える位置まで下げられます。ダイナミックでは手札を半分隠し、ホバーまたはタップしたカードを持ち上げます。",
  "match.view.hideHand": "手札を隠す",
  "match.view.showHand": "手札を表示",

  "settings.fullscreen.label": "フルスクリーン固定",
  "settings.fullscreen.description":
    "PCやモバイルでフルスクリーン表示を強制し、アドレスバーを非表示にします。",

  "settings.controller.label": "コントローラー",
  "settings.controller.connected": "接続済み",
  "settings.controller.none": "未検出",
  "settings.controller.description":
    "十字キーで設定項目を移動します。Aでその設定の選択肢を開き、もう一度Aで値を選択します。テキスト欄ではスクリーンキーボードが開きます（Aで入力、Bで閉じる）。SelectまたはStartでナビゲーションバーと現在の画面を切り替えます。",

  "settings.chat.label": "チャット",
  "settings.chat.turnOff": "チャットをオフにする",
  "settings.chat.reviewTerms": "チャット規約を確認",
  "settings.chat.muted": "このアカウントではチャットが無効になっています。",
  "settings.chat.on":
    "チャットはオンです。オフにするとすべてのチャットメッセージが非表示になり、送信もできなくなります。再度オンにするには、チャット規約をもう一度確認して同意する必要があります。",
  "settings.chat.off":
    "チャットはオフです。メッセージの閲覧と送信には、チャット規約を確認して同意してください。",
  "settings.chat.locked":
    "チャットはオフです。アカウント作成から24時間以上経過するか、降参せずに{games}試合を完了すると解放されます。",

  "settings.blocked.label": "ブロック中のプレイヤー",
  "settings.blocked.unblock": "ブロック解除",
  "settings.blocked.description":
    "ブロックしたプレイヤーのチャットメッセージと対戦中のエモートは表示されず、対戦を申し込まれることもありません。ソーシャル、ランキング、チャット、または対戦中のプレイヤープレビューにあるプロフィールからブロックできます。",

  "settings.adventure.label": "アドベンチャー",
  "settings.adventure.reset": "アドベンチャーをリセット",
  "settings.adventure.description":
    "アドベンチャーのセーブデータを削除し、最初からやり直せます。アドベンチャーモードを始めている場合、セーブデータ全体（マップ、インベントリ、効果など）がリセットされます。",
  "settings.adventure.none": "リセットするアドベンチャーのセーブデータはありません。",
  "settings.adventure.confirmTitle": "アドベンチャーをリセットしますか？",
  "settings.adventure.confirmBody":
    "マップの進行状況、インベントリ、アドベンチャーデッキ、ゴールド、進行中のアドベンチャーの遭遇や戦闘を含むセーブデータが完全に削除されます。最初からやり直しになります。",

  "settings.deleteAccount.label": "アカウント削除",
  "settings.deleteAccount.description":
    "このアカウント、ログイン情報、すべての進行状況を完全に削除します。元に戻すことはできません。",
  "settings.deleteAccount.typeUsername": "ユーザー名を入力してください（{username}）",
  "settings.deleteAccount.deleting": "削除中…",
  "settings.deleteAccount.forever": "アカウントを完全に削除",

  "deck.aspect": "アスペクト",
  "deck.equipment": "装備",
  "deck.ability": "アビリティ",
  "deck.defaultName": "デッキ",
  "deck.newDeck": "新しいデッキ",
  "deck.totalPower": "合計パワー",
  "deck.filters.allCards": "すべてのカード",
  "deck.filters.allAttributes": "すべての属性",
  "deck.attr.strength": "筋力",
  "deck.attr.dexterity": "敏捷",
  "deck.attr.wisdom": "知恵",
  "deck.attr.neutral": "中立",
  "deck.filters.allResources": "すべてのリソース",
  "deck.filters.allCosts": "すべてのコスト",
  "deck.filters.allCostsResources": "すべてのコスト/リソース",
  "deck.filters.fewer": "フィルターを減らす",
  "deck.filters.more": "その他のフィルター",
  "deck.filters.holoUnlocked": "ホロ解放済み",
  "deck.filters.cardsUnlocked": "カード：解放済み",
  "deck.filters.cardsLocked": "カード：未解放",
  "deck.filters.cardsAll": "カード：すべて",
  "deck.filters.clear": "フィルターをクリア",
  "deck.filters.searchPlaceholder": "名前、効果、コストで検索…",
  "deck.filters.allSlots": "すべてのスロット",
  "deck.filters.allItemTypes": "すべての装備タイプ",
  "deck.filters.allTiers": "すべてのティア",
  "deck.filters.allKinds": "すべての種別",
  "deck.kind.active": "アクティブ",
  "deck.kind.augment": "強化",
  "deck.kind.essence": "エッセンス",
  "deck.filters.allTypes": "すべてのタイプ",
  "deck.filters.allEffects": "すべての効果",
  "deck.filters.sortBy": "並び替え：{label}",
  "deck.catalog.resultCount_other": "{count}枚",
  "deck.variant.label": "バリアント",
  "deck.variant.base": "ベース",
  "deck.variant.confirm": "決定",
  "deck.pager.previous": "前のページ",
  "deck.pager.next": "次のページ",
  "deck.pager.pageOf": "ページ {page}/{total}",
  "deck.pager.perPage": "1ページ{n}件",
  "deck.pager.all": "すべて",
  "deck.share.exportTitle": "デッキをエクスポート",
  "deck.share.importTitle": "デッキをインポート",
  "deck.share.pastePlaceholder": "デッキJSONを貼り付け",
  "deck.share.copied": "コピーしました",
  "deck.share.copy": "コピー",
  "deck.share.import": "インポート",
  "deck.analyze.none": "なし",
  "deck.analyze.noOutputs": "測定可能なアクション出力はありません。",
  "deck.analyze.output": "出力",
  "deck.analyze.avgPerCard": "平均/枚",
  "deck.analyze.total": "合計",
  "deck.analyze.sectionMeta": "{count}枚 · パワー {power}",
  "deck.analyze.avgCost": "平均コスト {cost}",
  "deck.analyze.kinds": "種別",
  "deck.analyze.boardSlots": "盤面スロット",
  "deck.analyze.equipmentSlots": "装備スロット",
  "deck.analyze.attributes": "属性",
  "deck.analyze.typesPresent": "含まれるタイプ",
  "deck.analyze.averageOutputs": "平均アクション出力",
  "deck.analyze.title": "分析 · {name}",
  "deck.analyze.overview": "{count}枚 · パワー {power}/{max}",
  "deck.analyze.attributesLabel": "属性：",
  "deck.analyze.typesLabel": "タイプ：",
  "deck.analyze.aspectMeta": "{name} · パワー {power}",
  "deck.analyze.noneSelected": "未選択",
  "deck.analyze.types": "タイプ",
  "deck.analyze.pickAspect": "アスペクトを選ぶとここに表示されます。",
  "deck.recommend.unknownCard": "不明なカード",
  "deck.recommend.title": "変更を提案 · {name}",
  "deck.recommend.aspectUnchanged": "アスペクト · 変更なし",
  "deck.recommend.swaps": "入れ替え",
  "deck.recommend.loading": "相性の良い入れ替えを検索中…",
  "deck.recommend.emptyTitle": "相性の良い入れ替えが見つかりません。",
  "deck.recommend.emptyBody": "スロットの網羅性、リソース供給、パワーの余裕を損なわずにこのデッキにより合う所持カードはありません。デッキは変更されていません。",
  "deck.recommend.staleNotice": "このプレビュー以降に、デッキ、カードデータ、またはコレクションが変更されました。",
  "deck.recommend.recommendAgainHint": "もう一度提案して新しい入れ替えを取得してください。",
  "deck.recommend.exhausted": "別の入れ替えは見つかりませんでした。前回の提案を表示しています。",
  "deck.recommend.equipmentSlot": "装備スロット {n}",
  "deck.recommend.abilitySlot": "アビリティスロット {n}",
  "deck.recommend.remove": "外す",
  "deck.recommend.add": "入れる",
  "deck.recommend.whyAdd": "追加理由",
  "deck.recommend.whyRemove": "除外理由",
  "deck.recommend.disclaimer": "提案はカード同士の関連性に基づくもので、強化を保証するものではありません。適用するとエディターが更新されます。変更を残すには保存してください。",
  "deck.recommend.apply": "変更を適用",
  "deck.recommend.again": "再提案",
  "deck.recommend.tryAgain": "再試行",
  "deck.recommend.button": "変更を提案",
  "deck.recommend.buttonTitle": "相性の良いカードの入れ替えを2〜4件提案",
  "deck.recommend.needsValidDeck": "変更の提案には、完成した有効なデッキが必要です。",
  "deck.slot.empty": "空き",
  "deck.slot.deckSlot": "デッキスロット",
  "deck.slot.clear": "スロットを空にする",
  "deck.slot.replaceCard": "カードを入れ替え",
  "deck.picker.replaceAspect": "アスペクトを入れ替え",
  "deck.picker.chooseAspect": "アスペクトを選択",
  "deck.picker.replaceEquipmentSlot": "装備スロット {n} を入れ替え",
  "deck.picker.chooseEquipmentSlot": "装備スロット {n} を選択",
  "deck.picker.replaceAbilitySlot": "アビリティスロット {n} を入れ替え",
  "deck.picker.chooseAbilitySlot": "アビリティスロット {n} を選択",
  "deck.picker.hideFilters": "フィルター/検索を隠す",
  "deck.picker.showFilters": "フィルター/検索を表示",
  "deck.picker.suggest": "カードを提案",
  "deck.sort.name": "並び替え：名前",
  "deck.sort.type": "並び替え：タイプ",
  "deck.sort.attribute": "並び替え：属性",
  "deck.sort.resources": "並び替え：リソース",
  "deck.sort.cost": "並び替え：コスト",
  "deck.sort.power": "並び替え：パワー",
  "deck.sort.slot": "並び替え：スロット",
  "deck.sort.kind": "並び替え：種別",
  "deck.sort.holo": "並び替え：ホロ数",
  "deck.builder.title": "デッキビルダー",
  "deck.builder.setDefault": "デフォルトに設定",
  "deck.builder.clone": "複製",
  "deck.builder.save": "保存",
  "deck.builder.delete": "削除",
  "deck.builder.export": "エクスポート",
  "deck.builder.analyze": "分析",
  "deck.builder.default": "デフォルト",
  "deck.builder.unsaved": "未保存",
  "deck.builder.deleteTitle": "デッキを削除しますか？",
  "deck.builder.deleteBody": "{name} を完全に削除します。この操作は取り消せません。",
  "match.board.healthCost": "体力{amount}",
  "match.board.alreadyPlayedAbility": "このターンはすでにアビリティをプレイしました。",
  "match.board.tagInherent": "固有",
  "match.board.tagCombo": "コンボ",
  "match.board.tagLevel": "Lv{level}",
  "match.board.tagActiveMinion": "{name} 稼働中 {hp}",
  "match.board.tagActiveAura": "{name} 発動中",
  "match.board.slotTitleCanLevelUp": "レベルアップ可能 · 選択して操作を表示",
  "match.board.slotTitleEmpowerArmor": "この物理防御カードを強化",
  "match.board.slotTitleLinkedAugment": "連携する強化に一致",
  "match.board.slotTitleSlotHere": "ここにアビリティをセット",
  "match.board.mismatch": "不一致",
  "match.board.expendedSuffix": " · 消費済み",
  "match.board.auraActiveTitle": "{name} · オーラ発動中",
  "match.board.linkedActiveUsed": "{name} · 連携アクティブ使用済み",
  "match.board.slotTitleInert": "{name} · ホストスロット外では無効",
  "match.board.costTitle": "コスト {cost}",
  "match.board.emptyAbilitySlot": "空のアビリティスロット",
  "match.board.fletchCounter_other": "フレッチチャージ {count}個",
  "match.board.activeBadge": "アクティブ",
  "match.board.you": "あなた",
  "match.board.opp": "相手",
  "match.board.timerMulligan": "マリガンタイマー",
  "match.board.timerTurn": "ターンタイマー",
  "match.board.timerMatch": "対戦タイマー",
  "match.board.mulligan": "マリガン",
  "match.board.yourTurn": "あなたのターン",
  "match.board.playerTurn": "{name}のターン",
  "match.board.firstPlayerWillBe": "先攻: {name} · ",
  "match.board.round": "ラウンド {round}",
  "match.board.peekEquipment": "装備",
  "match.board.noEquipment": "装備なし",
  "match.board.peekAbilities": "アビリティ",
  "match.board.noAbilities": "アビリティなし",
  "match.board.noOccupiedSlots": "使用中のスロットなし",
  "match.board.healthOrbLabel": "体力 {hp}/{maxHp}",
  "match.board.quests": "クエスト",
  "match.board.tapAgainToExpend": "もう一度タップで消費: {action}",
  "match.board.targetAspect": "アスペクトを対象にする",
  "match.board.aspect": "アスペクト",
  "match.board.aspectSlotLabel": "アスペクトスロット",
  "match.board.aspectSlot": "アスペクトスロット",
  "match.board.slotWeapon": "武器",
  "match.board.slotArmor": "防具",
  "match.board.slotTrinket": "装飾品",
  "match.board.minion": "ミニオン",
  "match.board.aura": "オーラ",
  "match.board.expend": "消費",
  "match.board.minionHealthLabel": "{name} 体力 {hp}/{maxHp}",
  "match.board.auraActiveLabel": "{name} 発動中",
  "match.board.hexed": "呪縛中",
  "match.board.expendCost": "消費 +{cost}",
  "match.board.equipHere": "ここに装備する",
  "match.board.slotTitle": "{slot}スロット",
  "match.board.slotAriaLabel": "{slot}スロット",
  "match.board.quickRefresh": "リフレッシュ",
  "match.board.quickEncore": "アンコール",
  "match.board.quickSlotDamage": "スロットDMG",
  "match.board.quickRepair": "修理",
  "match.board.gainResources": "リソースを得る",
  "match.board.dealDamage": "ダメージを与える",
  "match.board.heal": "回復",
  "match.board.physicalArmor": "物理防御",
  "match.board.magicArmor": "魔法防御",
  "match.board.resolveTargetingFirst": "先に対象を選択してください。",
  "match.board.equipmentBrokenCannotExpend": "その装備は壊れているため消費できません。",
  "match.board.equipmentCannotExpend": "その装備は消費できません。",
  "match.board.refreshRequiresExpended": "リフレッシュには消費済みの装備が必要です。",
  "match.board.cannotUseAction": "その操作は使用できません。",
  "match.board.equipmentAction": "装備アクション",
  "match.board.notEnoughPhysicalArmor": "物理防御が足りません。",
  "match.board.examine": "詳細",
  "match.board.deactivateAura": "オーラを解除",
  "match.board.effectFallback": "効果",
  "match.board.encore": "アンコール",
  "match.board.slottedDamage": "スロットダメージ +{amount}",
  "match.board.repair": "修理",
  "match.board.equipmentNotExpended": "装備は消費されていません。",
  "match.board.refresh": "リフレッシュ",
  "match.board.charge": "チャージ",
  "match.board.discard": "捨てる",
  "match.board.levelUpAbility": "アビリティをレベルアップ",
  "match.board.empowerEquipment": "装備を強化",
  "match.board.empowerAbility": "アビリティを強化",
  "match.board.unsummon": "召喚解除",
  "match.board.deactivate": "解除",
  "match.board.alreadyActivated": "このターンはすでに発動しました。",
  "match.board.minionAlreadyActive": "ミニオンはすでに稼働中です。",
  "match.board.auraAlreadyActive": "オーラはすでに発動中です。",
  "match.board.hostEquipmentOccupied": "ホスト装備は使用中です。",
  "match.board.unsummonMinionFirst": "先にミニオンの召喚を解除してください。",
  "match.board.deactivateAuraFirst": "先にオーラを解除してください。",
  "match.board.moveAbility": "アビリティを移動",
  "match.board.remainingActs": "残り行動:",
  "match.board.remainingEquip": "装備",
  "match.board.remainingAbility": "アビリティ",
  "match.board.remainingExpendGear": "装備消費",
  "match.board.remainingActivateAbilities": "アビリティ発動",
  "match.board.hintEquip": "1ターンに1回、手札の装備カードを空いている部位スロットに装備できます。",
  "match.board.hintAbility": "1ターンに1回、手札のアビリティを盤面にセットするか、セット済みのアビリティを空きスロットに移動できます。セット済みのアビリティを捨てるのは無料で、この行動を消費しません。",
  "match.board.hintExpendGear": "装備中のアイテムはそれぞれ1ターンに1回、リソースまたは消費効果のために消費できます。同じアイテムに複数の消費オプションがあっても1回として数えます。",
  "match.board.hintActivateAbilities": "このターンにまだ発動できる、未使用のセット済みアクティブアビリティの数です。発動時にはコストの支払いが必要です。",
  "match.board.notEnoughResources": "リソースが足りません。",
  "match.board.effectNumber": "効果 {number}",
  "match.board.actionNumber": "アクション {number}",
  "match.board.noEmptyAbilitySlots": "空いているアビリティスロットがありません。",
  "match.board.selectEmptyAbilitySlot": "空いているアビリティスロットを選択してください。",
  "match.panel.aspect": "アスペクト",
  "match.panel.aspectEmpty": "アスペクト · なし",
  "match.panel.equipment": "装備",
  "match.panel.slotEmpty": "{slot} · なし",
  "match.panel.minion": "ミニオン",
  "match.panel.aura": "オーラ",
  "match.panel.onEquipment": " · {name}に装着",
  "match.panel.charges": "チャージ",
  "match.panel.durability": "耐久値",
  "match.panel.broken": "（破損）",
  "match.panel.unsummon": "召喚解除",
  "match.panel.deactivate": "解除",
  "match.panel.gain": "獲得",
  "match.panel.toast.resolveTargetingFirst": "先に対象を選択してください。",
  "match.panel.toast.notEnoughPhysicalArmor": "物理防御が足りません。",
  "match.panel.toast.refreshRequiresExpended": "リフレッシュには消費済みの装備が必要です。",
  "match.panel.toast.equipmentCannotExpend": "その装備は消費できません。",
  "match.panel.toast.resolvePendingChoiceFirst": "先に保留中の選択を済ませてください。",
  "match.panel.refresh": "リフレッシュ",
  "match.panel.charge": "チャージ",
  "match.panel.encore": "アンコール",
  "match.panel.slottedDamageButton": "+{amount} スロットダメージ",
  "match.panel.repair": "修理",
  "match.panel.discard": "捨てる",
  "match.panel.examine": "詳細",
  "match.panel.traits": "特性",
  "match.panel.aspectTraitTreeAria": "{name}の特性ツリー",
  "match.panel.levelTrait": "レベル{level}特性",
  "match.panel.levelTraitLabel": "レベル{level}：{label}",
  "match.panel.aspectBaseEffect": "アスペクト基本効果",
  "match.panel.allocated": "習得済み",
  "match.panel.traitOption": "特性の選択肢",
  "match.panel.clickAnywhereToClose": "どこかをクリックして閉じる",
  "match.panel.tapNodeHint": "ノードをタップすると特性とアスペクト基本効果を確認できます。",
  "match.panel.viewArtAria": "{name}のアートを表示",
  "match.panel.variant": "バリアント",
  "match.panel.variantBase": "通常",
  "match.panel.expansionSetAria": "拡張セット：{set}",
  "match.panel.set": "セット",
  "match.panel.power": "パワー",
  "match.panel.attributes": "属性",
  "match.panel.attribute": "属性",
  "match.panel.kind": "種類",
  "match.panel.linksTo": "連携先",
  "match.panel.or": "または",
  "match.panel.matchingActiveAbilities": "対応するアクティブアビリティ",
  "match.panel.slot": "スロット",
  "match.panel.boardSlotSub": "盤面スロット：{slot}",
  "match.panel.matchEffect": "対戦効果",
  "match.panel.passive": "パッシブ",
  "match.panel.kindEffect": "{kind}効果",
  "match.panel.effect": "効果",
  "match.panel.effectLower": "効果",
  "match.panel.triggers": "トリガー",
  "match.panel.expend": "消費",
  "match.panel.equipmentActions": "装備アクション",
  "match.panel.cardText": "カードテキスト",
  "match.panel.invoke": "インヴォーク",
  "match.panel.levelProgression": "レベル推移",
  "match.panel.traitTree": "特性ツリー",
  "match.panel.tapArtToEnlarge": "アートをタップで拡大",
  "match.panel.ability": "アビリティ",
  "match.panel.health": "体力",
  "match.panel.expendedThisTurn": "このターン消費済み",
  "match.panel.minions": "ミニオン",
  "match.panel.hostEquipment": "装着先の装備 · {name}",
  "match.panel.appliedEffects": "付与中の効果",
  "match.panel.applyAbility": "{name}を適用",
  "match.panel.used": "使用済み",
  "match.panel.activeMinionStatus": "稼働中 {name} {hp}",
  "match.panel.activeStatus": "稼働中 {name}",
  "match.panel.mismatch": "不一致",
  "match.panel.level": "レベル",
  "match.panel.baseLevel": "基本 {level}",
  "match.panel.status": "状態",
  "match.panel.levelUpAbility": "アビリティをレベルアップ",
  "match.panel.exportGameLogTitle": "これまでのゲームログをJSONでダウンロード",
  "match.panel.exporting": "エクスポート中…",
  "match.panel.export": "エクスポート",
  "match.panel.noActionsYet": "まだ行動はありません。",
  "match.panel.quests": "クエスト",
  "match.panel.eachTurn": "毎ターン",
  "match.panel.eachTurnHint": "順不同で達成できます。次の自分のターン開始時にリセットされます。",
  "match.panel.duringGame": "対戦中",
  "match.panel.duringGameHint": "対戦ごとに1回、順不同で達成できます。",
  "match.panel.chooseSlottedResource": "セット中のアビリティに対応するリソースを選んでください。",
  "match.panel.convertNeutral": "中立1つを好きな属性に変換します。",
  "match.panel.chooseFocusResourcePrompt": "筋力・敏捷・知恵から1つ選び、そのリソースを1獲得します。",
  "match.panel.chooseIdentity": "アイデンティティを選択",
  "match.panel.chooseIdentityPrompt": "アイデンティティを選択。装備中、この装備は選んだ主属性になります。",
  "match.panel.levelUp": "レベルアップ",
  "match.panel.levelN": "レベル{level}",
  "match.panel.tierN": "ティア{tier}",
  "match.panel.tier": "ティア",
  "match.panel.selected": "選択済み",
  "match.panel.notChosen": "未選択",
  "match.panel.futureChoice": "今後の選択肢",
  "match.panel.traitChoiceHint": "光っているノードを選び、確定して特性を決定します。",
  "match.panel.traitTreeAria": "特性ツリー",
  "match.panel.viewBoard": "盤面を見る",
  "match.panel.confirmTrait": "特性を確定",
  "match.panel.clickOutsideToClose": "外側をクリックして閉じる",
  "match.panel.showLevelUpPrompt": "レベルアップ案内を表示",
  "match.panel.hideLevelUpPrompt": "レベルアップ案内を隠す",
  "match.panel.levelUpAbilityPrompt": "ハイライトされた{attribute}アビリティを選び、「アビリティをレベルアップ」か「スキップ」（+3 XP）を選んでください。",
  "match.panel.empowerPhysicalArmorCard": "物理防御カードを強化",
  "match.panel.empowerEquipment": "装備を強化",
  "match.panel.empowerPhysicalArmorHint": "黄色くハイライトされた、物理防御を付与するセット中のアビリティを選んでレベルアップするか、消費効果で物理防御を付与する装備を選んでその消費時の物理防御を1増やす（常時の物理防御は変わりません）か、スキップして+3 XPを得ます。",
  "match.panel.empowerEquipmentHint": "黄色くハイライトされた、魔法防御を付与する知恵の装備を選んで、常時の魔法防御と消費時の魔法防御をそれぞれ1増やすか、スキップして+3 XPを得ます。",
  "match.panel.chargeResourceSpend": "{label}：{current}。{per}ずつ消費して筋力・敏捷・知恵を獲得します。",
  "match.panel.allocateUpTo": "最大{max}まで割り当て。残り{remaining}。",
  "match.panel.maxValue": "最大 {max}",
  "match.panel.confirm": "確定",
  "match.panel.payFor": "{name}の支払い",
  "match.panel.spendAnyFlex": "筋力・敏捷・知恵・中立から任意に{amount}を支払う",
  "match.panel.remaining": "残り {amount}",
  "match.panel.decreaseAria": "{attribute}を減らす",
  "match.panel.increaseAria": "{attribute}を増やす",
  "match.panel.hiddenCard": "非公開カード",
  "match.panel.discardAndDraw": "捨ててドロー",
  "match.panel.equip": "装備する",
  "match.panel.slotAction": "セット",
  "match.panel.plusOnePhysArmor": "+1 物理防御",
  "match.view.enemies": "敵",
  "match.view.statusBleed": "出血 {amount}",
  "match.view.statusPoison": "毒 {amount}",
  "match.view.statusBurn": "火傷 {amount}",
  "match.view.statusChill": "冷気 {amount}",
  "match.view.statusShock": "感電 {amount}",
  "match.view.statusWither": "衰弱 {amount}",
  "match.view.statusHex": "呪詛 {amount}",
  "match.view.statusRegen": "再生 {amount}",
  "match.view.regeneration": "再生",
  "match.view.wither": "衰弱",
  "match.view.enemyDefeated": "撃破済み",
  "match.view.enemySelectedTarget": "選択中の対象",
  "match.view.enemySelect": "敵を選択",
  "match.view.enemyExamine": "敵の詳細",
  "match.view.emptyEnemySlotAria": "空の敵スロット {slot}",
  "match.view.emptySlot": "空き",
  "match.view.matchOver": "対戦終了",
  "match.view.waitingForSummary": "結果を待っています…",
  "match.view.resultDraw": "引き分け",
  "match.view.endedTimeout": "時間切れ",
  "match.view.endedCombat": "戦闘",
  "match.view.tutorialComplete": "チュートリアル完了",
  "match.view.tryAgain": "再挑戦",
  "match.view.victory": "勝利",
  "match.view.defeat": "敗北",
  "match.view.deckPower": "パワー {total}/{max}",
  "match.view.deckAspectPower": "アスペクト · パワー {power}",
  "match.view.deckEquipmentPower": "装備 ({cards}) · パワー {power}",
  "match.view.deckAbilitiesPower": "アビリティ ({cards}) · パワー {power}",
  "match.view.noneRemaining": "残りなし",
  "match.view.you": "あなた",
  "match.view.winner": "勝者",
  "match.view.board": "ボード",
  "match.view.handCount": "手札 ({n})",
  "match.view.deckCount": "デッキ ({n})",
  "match.view.discardCount": "捨て札 ({n})",
  "match.view.continue": "続ける",
  "match.view.adNotCompleted": "広告の視聴が完了しませんでした。",
  "match.view.adStartFailed": "広告を開始できませんでした。",
  "match.view.adExtraUnlock": "広告を視聴して追加アンロック",
  "match.view.unlockedCards_other": "カードを{count}枚アンロック",
  "match.view.unlockedFoils_other": "フォイル報酬を{count}件アンロック",
  "match.view.bonusAvailable": "ボーナス{bonus}件あり",
  "match.view.earned": "獲得",
  "match.view.adPromptTitle": "広告を視聴しますか？",
  "match.view.adPromptBody": "短い広告を視聴して、アンロック済みカードの追加フォイル版をアンロックしますか？広告収入はサーバー費用と今後の開発に充てさせていただきます。ご支援に心より感謝いたします！",
  "match.view.loading": "読み込み中...",
  "match.view.adWatch": "広告を視聴",
  "match.view.notNow": "今はしない",
  "match.view.none": "なし",
  "match.view.endedBy": "終了理由",
  "match.view.rounds": "ラウンド数",
  "match.view.opponent": "相手",
  "match.view.damageDealt": "与ダメージ",
  "match.view.damageTaken": "被ダメージ",
  "match.view.healed": "回復量",
  "match.view.throwAway": "捨てる",
  "match.view.reportChooseCategory": "通報カテゴリを選択してください。",
  "match.view.chatTurnedOff": "チャットはオフです。再びオンにするにはチャット規約をご確認ください。",
  "match.view.queueTitle": "対人戦の相手を検索中...",
  "match.view.playersInQueue": "待機中のプレイヤー: {players}",
  "match.view.cancelQueue": "検索をキャンセル",
  "match.view.discardPileAria": "{name}の捨て札",
  "match.view.discardViewerHint": "新しい順に表示。カードをタップすると詳細を表示します。",
  "match.view.discardEmpty": "捨て札にカードはありません。",
  "match.view.account.passwordTooShort": "パスワードは4文字以上にしてください。",
  "match.view.account.passwordMismatch": "新しいパスワードが一致しません。",
  "match.view.account.passwordUpdated": "パスワードを更新しました。",
  "match.view.account.changePasswordFailed": "パスワードを変更できませんでした。",
  "match.view.account.requestFailed": "リクエストに失敗しました。",
  "match.view.account.typeUsernameToConfirm": "確認のため、ユーザー名を正確に入力してください。",
  "match.view.account.enterCurrentPassword": "現在のパスワードを入力してください。",
  "match.view.account.deleteFailed": "アカウントを削除できませんでした。",
  "match.view.account.enterUsername": "ユーザー名を入力してください。",
  "match.view.account.usernameNoSpaces": "ユーザー名にスペースは使用できません。",
  "match.view.account.createFailed": "アカウントを作成できませんでした。",
  "match.view.winnerBanner": "勝者: {name}",
  "match.view.quickUseEquipment": "装備をまとめてリソース化",
  "match.view.quickUseAbilities": "ダメージアビリティを一括使用",
  "match.view.hand": "手札",
  "match.view.noCardsInHand": "手札にカードがありません",
  "match.view.handHint": "これはあなたの手札です。装備デッキとアビリティデッキはまとめてシャッフルされます。手札は最大4枚までで、自分のターン開始時に上限まで補充されます。装備カードは1ターンに1枚装備でき、アビリティの操作も1ターンに1回行えます（空きスロットへのセット、セット済みアビリティの移動、または手札へのセット解除）。",
  "match.guide.label": "ガイド",
  "match.guide.show": "ガイドを表示",
  "match.guide.hide": "ガイドを最小化",
  "match.guide.turnOff": "ガイドをオフにする",
  "match.guide.turnedOff": "対戦ガイドをオフにしました。設定から再度オンにできます。",
  "match.guide.title.openingHand": "初期手札",
  "match.guide.title.yourTurn": "あなたのターン",
  "match.guide.title.opponentTurn": "相手のターン",
  "match.guide.title.makeChoice": "選択してください",
  "match.guide.mulligan": "この手札で始めるか、マリガンを1回押して引き直します。準備ができたら準備完了を押してください。",
  "match.guide.mulliganWaiting": "相手の準備を待っています。",
  "match.guide.opponentTurn": "相手のプレイを確認しましょう。カードをタップすると詳細を確認できます。手札は自分のターン開始時に補充されます。",
  "match.guide.pendingChoice": "他の行動をする前に、ハイライトされた選択（対象や選択肢）を完了するか、キャンセルしてください。",
  "match.guide.playEquipment": "装備：手札の光っている装備カードをタップして「装備する」を押します（1ターンに1回）。",
  "match.guide.slotAbility": "アビリティ：手札の光っているアビリティカードをタップしてセットを押し、空きスロットを選びます（1ターンに1回）。",
  "match.guide.expendEquipment_one": "消費：ボード上の光っている装備をタップして、リソースまたは効果を得ます。",
  "match.guide.expendEquipment_other": "消費：ボード上の光っている装備をタップして、リソースまたは効果を得ます（残り{count}）。",
  "match.guide.activateAbilities_one": "発動：ボード上の光っているアビリティをタップして使います。",
  "match.guide.activateAbilities_other": "発動：ボード上の光っているアビリティをタップして使います（残り{count}）。",
  "match.guide.needResources": "リソースが足りないアビリティがあります。先に装備を消費して支払いましょう。",
  "match.guide.nothingLeft": "これ以上できることはありません。ターン終了を押してください。",
  "match.guide.idle": "迷ったら、いつでもターン終了を押せます。",
  "match.guide.invoke": "任意：手札のカードを1枚捨てて、そのインヴォーク効果を使えます。",
  "match.view.viewingYourBoard": "自分のボードを表示中",
  "match.view.viewingEnemies": "敵を表示中",
  "match.view.viewingPlayerBoard": "{name}のボードを表示中",
  "match.view.cycleBoardView": "ボード表示を切り替え",
  "match.view.viewLabel": "表示",
  "match.view.viewEnemy": "敵",
  "match.view.viewAlly": "味方",
  "match.view.viewOpp": "相手",
  "match.view.viewSelf": "自分",
  "match.view.showMatchEmotes": "対戦中のエモートを表示",
  "match.view.hideAllMatchEmotes": "対戦中のエモートをすべて非表示",
  "match.view.showEmotes": "エモート表示",
  "match.view.hideEmotes": "エモート非表示",
  "match.view.emotes": "エモート",
  "match.view.sendEmote": "エモート {emoji} を送信",
  "match.view.mulliganed": "マリガン済み",
  "match.view.mulligan": "マリガン",
  "match.view.closeEmotes": "エモートを閉じる",
  "match.view.openEmotes": "エモートを開く",
  "match.view.emote": "エモート",
  "match.view.ready": "準備完了",
  "match.view.cancelEffectUse": "効果の使用を取り消す",
  "match.view.cancelAbilityUse": "アビリティの使用を取り消す",
  "match.view.cancelEffectUseConfirm": "効果の使用を取り消しますか？",
  "match.view.cancelAbilityUseConfirm": "アビリティの使用を取り消しますか？",
  "match.view.skipAbilityLevelUpTitle": "アビリティのレベルアップをスキップして+3 XP",
  "match.view.skip": "スキップ",
  "match.view.chooseAbilityOrSkipTitle": "ターン終了前に、ハイライトされたアビリティを選ぶかスキップしてください",
  "match.view.endTurnLine1": "ターン",
  "match.view.endTurnLine2": "終了",
  "match.view.skipEquipmentTraitTitle": "装備の特性をスキップして+3 XP",
  "match.view.chooseAbilityOrEquipmentOrSkipTitle": "ターン終了前に、ハイライトされたアビリティか装備を選ぶかスキップしてください",
  "match.view.chooseEquipmentOrSkipTitle": "ターン終了前に、ハイライトされた装備を選ぶかスキップしてください",
  "match.view.chooseTraitLine1": "特性を",
  "match.view.chooseTraitLine2": "選択",
  "match.view.viewBoardLine1": "ボードを",
  "match.view.viewBoardLine2": "表示",
  "match.view.chooseTraitTitle": "ターン終了前に特性を選んでください",
  "match.view.chooseIdentityLine1": "アイデンティティを",
  "match.view.chooseIdentityLine2": "選択",
  "match.view.chooseIdentityTitle": "ターン終了前にアイデンティティを選んでください",
  "match.view.noResourcesSpent": "リソースは消費されません。",
  "match.view.noRefund": "{name}のコストは返還されません。",
  "match.view.thisEffect": "この効果",
  "match.view.keepTargeting": "対象選択を続ける",
  "game.toast.error": "エラー",
  "game.toast.yourTurn": "あなたのターン",
  "game.toast.yourTurnOpeningBlocked": "あなたのターン · 先攻のため、最初のターンはダメージを与えられません",
  "game.gameLog.exportFailed": "ゲームログをエクスポートできませんでした。",
  "game.gameLog.copied": "ゲームログをクリップボードにコピーしました（{entries}件）",
  "game.gameLog.exported": "ゲームログをエクスポートしました（{entries}件）",
  "game.payment.kind.ability": "アビリティ",
  "game.payment.kind.sharpen": "研ぎ",
  "game.payment.kind.hone": "研磨",
  "game.payment.kind.fletch": "矢作り",
  "game.payment.kind.encore": "アンコール",
  "game.payment.kind.research": "研究",
  "game.payment.kind.repair": "修理",
  "game.deck.recommendStale": "デッキが変更されました。もう一度おすすめを実行して新しい入れ替え案を取得してください。",
  "game.deck.recommendInvalid": "この入れ替え案は無効になりました。",
  "game.deck.recommendApplied_other": "{count}件の入れ替えを適用しました。保存して確定してください。",
  "game.deck.limitReached": "デッキ数の上限に達しました。",
  "game.deck.imported": "{name}をインポートしました",
  "game.workshop.seatOpponent": "相手",
  "game.workshop.seatYou": "あなた",
  "game.workshop.maxCopies": "{name}は最大{max}枚までです。",
  "game.workshop.addedToAbilityHand": "アビリティ手札に追加しました。スロットを選択してください。",
  "common.attribute.strength": "筋力",
  "common.attribute.dexterity": "敏捷",
  "common.attribute.wisdom": "知恵",
  "common.attribute.neutral": "中立",
  "deck.sort.name": "名前",
  "deck.sort.category": "カテゴリ",
  "deck.sort.type": "タイプ",
  "deck.sort.attribute": "属性",
  "deck.sort.resources": "リソース",
  "deck.sort.cost": "コスト",
  "deck.sort.power": "パワー",
  "deck.sort.slot": "スロット",
  "deck.sort.tier": "ティア",
  "deck.sort.kind": "種類",
  "deck.sort.holo": "ホロ数",
  "match.quest.equip": "装備カードを装備する",
  "match.quest.slotAbility": "アビリティカードをスロットにセットする",
  "match.quest.resourceExpend": "リソースを1以上獲得する",
  "match.quest.combatDamage": "ブロックされないダメージを与える",
  "match.quest.healBuff": "回復やアーマーなどの支援効果を得る",
  "match.quest.fullEquipment": "3つの装備スロットすべてに同時に装備する",
  "match.quest.fullAbilities": "3つのアクティブまたはメインスロットすべてに同時にアビリティをセットする",
  "match.quest.equipAllSlots": "各装備部位を少なくとも1回装備する",
  "match.quest.activateLevel2Ability": "スロットにセットしたレベル2アビリティを1回発動する",
  "match.quest.activateAugmentedAbility": "対応する強化付きのアビリティを1回発動する",
  "match.questStep.weapon": "武器",
  "match.questStep.trinket": "装飾品",
  "match.questStep.body": "胴",
  "match.questStep.hands": "手",
  "match.questStep.feet": "足",
  "match.questStep.head": "頭",
  "game.serverToast.mulliganFirstPlayer": "マリガンフェイズ - 先攻は{name}です",
  "game.serverToast.ranOutOfTime": "時間切れです！",
  "match.lobby.backToMatch": "対戦に戻る",
  "match.lobby.classic": "クラシック",
  "match.lobby.queueVsCpu": "CPUと対戦",
  "match.lobby.vsCpu": "VS CPU",
  "match.lobby.playersInQueue_other": "待機中のプレイヤー: {count}",
  "match.lobby.queueVsHuman": "プレイヤーと対戦",
  "match.lobby.vsHuman": "VS プレイヤー",
  "match.lobby.cancelQueue": "待機をキャンセル",
  "match.lobby.enterQueueVsHuman": "プレイヤー対戦の待機に参加",
  "match.lobby.playAgainstCpu": "CPUと対戦する",
  "match.lobby.setValidDeck": "待機に参加する前に有効なデッキを設定してください。",
  "match.lobby.currentDeck": "現在のデッキ:",
  "match.lobby.randomDeck": "🎲 ランダムデッキ",
  "match.lobby.randomDeckHint": "待機に参加するときに、有効なデッキからランダムに選ばれます。",
  "match.lobby.deckPreview": "デッキプレビュー",
  "match.lobby.noAspect": "アスペクトなし",
  "match.lobby.modes": "モード",
  "match.lobby.collectDraftRewards": "ドラフト報酬を受け取る",
  "match.lobby.continueDraftMode": "ドラフトモードを続ける",
  "match.lobby.playDraftModeFree": "ドラフトモードをプレイ（無料）",
  "match.lobby.playDraftModeCost": "ドラフトモードをプレイ（{cost} 通貨）",
  "match.lobby.collectDraft": "ドラフト報酬",
  "match.lobby.continueDraft": "ドラフトを続ける",
  "match.lobby.draftFree": "ドラフト（無料）",
  "match.lobby.draft": "ドラフト",
  "match.lobby.continueAdventureMode": "アドベンチャーモードを続ける",
  "match.lobby.playAdventureMode": "アドベンチャーモードをプレイ",
  "match.lobby.continueAdventure": "アドベンチャーを続ける",
  "match.lobby.adventure": "アドベンチャー",
  "match.lobby.tutorialScenarios": "チュートリアルシナリオ",
  "match.lobby.tutorials": "チュートリアル",
  "match.lobby.draftStatus": "ドラフト: ライフ {lives} · {played}/{max} 戦 · 勝 {wins} / 敗 {losses} / 分 {draws}",
  "match.lobby.draftRound": "ドラフト: ラウンド {round}/{total}",
  "match.lobby.collectDraftFirst": "新しいランを始める前にドラフト報酬を受け取ってください。",
  "match.popup.challengeTitle": "対戦申し込み",
  "match.popup.challengeBody": "{name}から対戦を申し込まれました。",
  "match.popup.partyInviteTitle": "パーティー招待",
  "match.popup.partyInviteBody": "{name}からアドベンチャーパーティーに招待されました。",
  "match.popup.leaveCpuTitle": "CPU戦を抜けますか？",
  "match.popup.leaveCpuBody": "対戦を降参して抜け、申し込みを受けますか？",
  "match.popup.accept": "受ける",
  "match.popup.decline": "断る",
  "match.popup.leaveSpectateTitle": "観戦をやめますか？",
  "match.popup.forfeitTitle": "降参しますか？",
  "match.popup.leaveSpectateBody": "この対戦の観戦を終了します。",
  "match.popup.forfeitBody": "この対戦は敗北となり、すぐに退出します。",
  "match.popup.leave": "退出",
  "match.popup.forfeit": "降参",
  "match.popup.loseTitle": "敗北することになります",
  "match.popup.loseBodyEquip": "{name}を装備すると敗北します。",
  "match.popup.loseBodyActivate": "{name}を発動すると敗北します。",
  "match.popup.confirm": "確定",
  "match.popup.disconnected": "切断されました",
  "match.popup.reconnecting": "接続が切れました。再接続しています…",
  "match.popup.hideHint": "ヒントを隠す",
  "common.back": "戻る",
  "common.returnToMenu": "メニューに戻る",
  "common.currencyAmount": "{amount} 通貨",
  "draft.title": "ドラフトモード",
  "draft.draftedCards": "ドラフト済みカード",
  "draft.aspectCount": "アスペクト ({n})",
  "draft.equipmentCount": "装備 ({n})",
  "draft.abilityCount": "アビリティ ({n})",
  "draft.noneYet": "まだありません。",
  "draft.roundChoice": "ラウンド {round}/{total} · {kind}を選択",
  "draft.forfeit": "ドラフトを放棄",
  "draft.pick": "ピック",
  "draft.forfeitTitle": "ドラフトを放棄しますか？",
  "draft.forfeitBody": "ドラフト全体が終了します。",
  "draft.deckTitle": "ドラフトデッキ",
  "draft.deckStatus": "ライフ {lives}/{maxLives} · 試合 {played}/{maxGames} · 勝 {wins} / 敗 {losses} / 分 {draws}",
  "draft.deckCounts": "アスペクト {aspect}/1 · 装備 {equipment}/{min} · アビリティ {ability}/{min} · プール: アスペクト {poolAspect} / 装備 {poolEquipment} / アビリティ {poolAbility}",
  "draft.queueCpu": "CPUとドラフト対戦",
  "draft.queueHuman": "プレイヤーとドラフト対戦を待機",
  "draft.buildHint": "ドラフトしたカードで装備10枚／アビリティ10枚のデッキを組みましょう。",
  "draft.complete": "ドラフト完了",
  "draft.collectRewards": "報酬を受け取る",
  "draft.livesRemaining": "残りライフ {lives}",
  "draft.record": "勝 {wins} / 敗 {losses} / 分 {draws}",
  "draft.games": "試合数 {games}",
  "draft.reward": "報酬",
  "draft.wizardFoils": "ドラフトウィザードのフォイル {n}",
  "draft.deckAspect": "デッキのアスペクト",
  "draft.deckEquipment": "デッキの装備",
  "draft.deckAbility": "デッキのアビリティ",
  "draft.poolAspect": "プールのアスペクト",
  "draft.poolEquipment": "プールの装備",
  "draft.poolAbility": "プールのアビリティ",
  "draft.costToast": "ドラフトモードは {cost} 通貨が必要です（米国中部時間16:00以降、1日1回無料）。",
  "adventure.title": "アドベンチャーモード",
  "adventure.hp": "HP {hp}/{maxHp}",
  "adventure.gold": "ゴールド {gold}",
  "adventure.intention": "行動予定: {intention}",
  "adventure.actsEvery_other": "{count}ターンごとに行動",
  "adventure.nextSuffix": "（次）",
  "adventure.intentNext": "次: {summary}",
  "adventure.intentIn": "{turns}ターン後: {summary}",
  "adventure.unknown": "不明",
  "adventure.attack": "攻撃",
  "adventure.attackDamage": "{type}ダメージ {damage}",
  "adventure.attackHeal": "回復 {heal}（{target}）",
  "adventure.healTargetAllies": "味方全体",
  "adventure.healTargetAlly": "味方1体",
  "adventure.healTargetSelf": "自身",
  "adventure.damageType.physical": "物理",
  "adventure.damageType.magical": "魔法",
  "adventure.damageType.fire": "火",
  "adventure.damageType.cold": "冷気",
  "adventure.damageType.lightning": "雷",
  "adventure.enemy": "敵",
  "adventure.enemyType": "種類: {name}",
  "adventure.node": "地点",
  "adventure.nodeType.start": "キャンプ",
  "adventure.nodeType.combat": "戦闘",
  "adventure.nodeType.shop": "ショップ",
  "adventure.nodeType.reward": "宝物",
  "adventure.nodeType.story": "ストーリー",
  "adventure.preview.unknown": "不明な遭遇。",
  "adventure.preview.combat": "戦闘の遭遇。",
  "adventure.preview.shop": "ショップ。",
  "adventure.preview.reward": "宝の隠し場所。",
  "adventure.preview.story": "ストーリーイベント。",
  "adventure.chooseNodeTitle": "{name}を選びますか？",
  "adventure.travelNodeTitle": "{name}へ移動しますか？",
  "adventure.chooseUnknownTitle": "未知の地点を選びますか？",
  "adventure.travelUnknownTitle": "未知の地点へ移動しますか？",
  "adventure.pathHidden": "到着するまで先の道は分かりません。",
  "adventure.partyMustConfirm": "イベント開始前にパーティーメンバー全員の確認が必要です。",
  "adventure.fillDeckBeforeTravel": "移動する前に、アドベンチャーデッキを装備10枚とアビリティ10枚で埋めてください。",
  "adventure.choose": "選ぶ",
  "adventure.travel": "移動",
  "adventure.fillEverySlot": "移動する前に、インベントリのカードでアドベンチャーデッキの全スロットを埋めてください。各デッキは10枚で、同じカードは最大{max}枚までです。",
  "adventure.waitingPartyConfirm": "パーティーの確認待ち ({ready}/{total})",
  "adventure.confirmReady": "準備完了",
  "adventure.effects": "効果",
  "adventure.activeEffects": "発動中の効果",
  "adventure.noActiveEffects": "発動中の効果はありません。",
  "adventure.inventoryCount": "インベントリ {n}/{max}",
  "adventure.defaultDeckName": "見習いの荷物",
  "adventure.deckCounts": "{name} · アスペクト {aspect}/1 · 装備 {equipment}/{min} · アビリティ {ability}/{min}",
  "adventure.deckEditHint": "スロットをタップすると、確認・クリア・インベントリのカードとの入れ替えができます。再び移動するには、各カード最大{max}枚で全スロットを埋めてください。",
  "adventure.leave": "置いていく",
  "adventure.take": "取る",
  "adventure.party": "パーティー",
  "adventure.partyHint": "アドベンチャーモードのメニューでオンラインのプレイヤーを招待できます。最大4人。",
  "adventure.partyLeader": "リーダー: {name}",
  "adventure.leaderSuffix": "（リーダー）",
  "adventure.invitedYou": "{name}から招待されました",
  "adventure.invite": "招待",
  "adventure.noEligible": "招待できるオンラインのプレイヤーがいません。",
  "adventure.leaveParty": "パーティーを抜ける",
  "adventure.waitingParty": "パーティーを待っています…",
  "adventure.combatSummary": "戦闘結果",
  "adventure.resultGold": "{result} · 獲得ゴールド {gold}",
  "adventure.enemiesDefeated_other": "敵 {count}体中 {defeated}体を撃破",
  "adventure.rewards": "報酬",
  "adventure.rewardHint": "カードをタップで確認 · 「取る」で報酬を予約、「置いていく」でスキップ",
  "adventure.continueWhenReady": "準備ができたら続行",
  "adventure.resolvingCombat": "戦闘を処理中...",
  "adventure.shop": "ショップ",
  "adventure.shopHint": "ゴールド {gold} · カードをタップで確認",
  "adventure.buyGold": "{price} ゴールドで購入",
  "adventure.leaveShopWhenReady": "準備ができたらショップを出る",
  "adventure.leaveShop": "ショップを出る",
  "adventure.treasure": "宝物",
  "adventure.treasureHint": "ゴールド {gold} · カードをタップで確認 · 「取る」で報酬を予約、「置いていく」でスキップ",
  "adventure.story": "ストーリー",
  "adventure.youGain": "獲得: {effects}",
  "adventure.enteringCombat": "戦闘に突入中…",
  "adventure.tabDeck": "アドベンチャーデッキ",
  "adventure.tabInventory": "インベントリ",
  "adventure.tabMap": "マップ",
  "common.player": "プレイヤー",
  "common.hoursMinutesShort": "{hours}時間{minutes}分",
  "common.minutesShort": "{minutes}分",
  "social.report": "通報",
  "social.block": "ブロック",
  "customize.board": "ボード",
  "customize.nameColor": "名前の色",
  "customize.lockedSuffix": "（ロック中）",
  "customize.unlockFor": "{name}を{cost}で解放",
  "customize.confirmPurchase": "もう一度タップで購入",
  "customize.boardName.flat": "フラット",
  "customize.boardName.elegant": "エレガント",
  "customize.boardName.ice": "氷",
  "customize.boardName.nature": "自然",
  "customize.boardName.volcanic": "火山",
  "customize.boardName.castle": "城",
  "customize.boardName.factory": "工場",
  "customize.boardName.swamp": "沼地",
  "customize.colorName.garnet": "ガーネット",
  "customize.colorName.scarlet": "スカーレット",
  "customize.colorName.amber": "アンバー",
  "customize.colorName.gold": "ゴールド",
  "customize.colorName.verdant": "新緑",
  "customize.colorName.forest": "フォレスト",
  "customize.colorName.abyss": "深淵",
  "customize.colorName.steel": "スチール",
  "customize.colorName.mist": "ミスト",
  "customize.colorName.white": "ホワイト",
  "customize.colorName.cyan": "シアン",
  "customize.colorName.azure": "アズール",
  "customize.colorName.sand": "サンド",
  "customize.colorName.clay": "クレイ",
  "customize.colorName.umber": "アンバー（土）",
  "customize.colorName.plum": "プラム",
  "customize.colorName.rainbow_holo": "レインボーホロ",
  "customize.colorName.metallic_holo": "メタリックホロ",
  "customize.colorName.gilded_holo": "ギルデッドホロ",
  "marketplace.refreshesIn": "更新まで {time}",
  "marketplace.cards": "カード",
  "marketplace.foils": "フォイル版",
  "marketplace.sold": "売り切れ",
  "marketplace.buy": "購入",
  "marketplace.confirmBuy": "購入を確定",
  "marketplace.noCards": "購入できる未解放カードはありません。",
  "marketplace.noFoils": "購入できるフォイル版はありません。",
  "marketplace.notEnough": "通貨が足りません。",
  "achievements.title": "実績",
  "achievements.close": "実績を閉じる",
  "achievements.ready": "受取可能 {n}",
  "achievements.completionReward": "達成報酬",
  "achievements.completionRewardCollected": "達成報酬は受取済み",
  "achievements.none": "まだ実績はありません。",
  "achievements.collected": "受取済み",
  "achievements.collect": "受け取る",
  "achievements.collectCompletionTitle": "達成報酬を受け取る",
  "achievements.collectAllFirst": "先にこのカテゴリの実績をすべて受け取ってください。",
  "achievements.view": "実績を見る",
  "achievements.dailies": "デイリー",
  "achievements.dailiesHint": "クラシック対戦でデイリーの進捗が進みます",
  "achievements.emptySlot": "空きスロット",
  "achievements.untilNewDaily": "新しいデイリーまで {time}",
  "achievements.newDailyArriving": "新しいデイリーが届きます...",
  "achievements.untilExpired": "期限まで {time}",
  "achievements.removeAgainAria": "もう一度押すとデイリーを削除: {label}",
  "achievements.removeAria": "デイリーを削除: {label}",
  "achievements.removeAgain": "もう一度押すと削除",
  "achievements.remove": "デイリーを削除",
  "achievements.rerollAgainAria": "もう一度押すと{cost}通貨でデイリーを再抽選: {label}",
  "achievements.rerollAria": "{cost}通貨でデイリーを再抽選: {label}",
  "achievements.rerollAgain": "もう一度押すと再抽選",
  "achievements.reroll": "このデイリーを再抽選（各デイリー1回まで）",
  "achievements.loadingDailies": "デイリーを読み込み中...",
  "dailies.dealDamage": "{type}ダメージを{target}与える",
  "dailies.applyAilment": "{ailment}を{target}付与する",
  "dailies.gainResource": "{attribute}を{target}獲得する",
  "dailies.playEquipment": "装備カードを{target}枚プレイする",
  "dailies.playAbility": "アビリティカードを{target}枚プレイする",
  "dailies.playAttribute": "{attribute}カードを{target}枚プレイする",
  "dailies.playKind": "{kind}アビリティを{target}枚プレイする",
  "dailies.playTag": "{tag}カードを{target}枚プレイする",
  "dailies.winWithAspect_other": "{name}で{count}回勝利する",
  "dailies.expendDamage": "装備をダメージのために{target}回消費する",
  "dailies.expendEffect": "装備をダメージ・リソース以外の効果のために{target}回消費する",
  "dailies.activateAbility": "アクティブアビリティを{target}回発動する",
  "dailies.invokeCards": "カードを{target}枚インヴォークする",
  "dailies.activateCard": "{name}を{target}回発動する",
  "dailies.ailment.burn": "火傷",
  "dailies.ailment.poison": "毒",
  "dailies.ailment.bleed": "出血",
  "dailies.ailment.shock": "感電",
  "dailies.ailment.chill": "冷気",
  "dailies.ailment.wither": "衰弱",
  "match.portrait.closeAria": "プレイヤー情報を閉じる",
  "match.portrait.deck": "デッキ: {n}",
  "match.portrait.hand": "手札: {n}",
  "match.portrait.discard": "捨て札: {n}",
  "common.loading": "読み込み中…",
  "common.ok": "OK",
  "common.loadingAssets": "アセットを読み込み中 {loaded}/{total}",
  "social.chatMuted": "ミュート中のため、チャットの閲覧や送信はできません。",
  "social.chatGuest":
    "チャットには登録アカウントが必要です。設定でアカウントを作成または移行してから戻ってきてください。",
  "social.chatLocked":
    "チャットはアカウント作成から24時間経過するか、投了せずに{games}試合を完了すると解放されます。進捗: {completed}/{games}試合完了。",
  "social.chatLockedRemaining":
    "チャットはアカウント作成から24時間経過するか、投了せずに{games}試合を完了すると解放されます。進捗: {completed}/{games}試合完了(残り{remaining})。",
  "social.chatAgreeTerms":
    "メッセージを閲覧・送信するには、ゲーム内チャットの利用規約に同意してください。",
  "social.players": "プレイヤー",
  "social.playersOnline": "{online} / {total} オンライン",
  "social.showPlayers": "プレイヤーを表示",
  "social.hidePlayers": "プレイヤーを隠す",
  "social.noPlayers": "プレイヤーがいません。",
  "social.noMessages": "まだメッセージはありません。",
  "social.messagePlaceholder": "メッセージ",
  "social.reportTitle": "{name}を通報",
  "social.reportPrompt":
    "どのような問題ですか?通報は非公開で、ATN DEVが確認します。",
  "social.reportCategory": "通報カテゴリー",
  "social.reportCategoryName.harassment": "嫌がらせ・いじめ・脅迫",
  "social.reportCategoryName.hate": "ヘイトスピーチ・差別",
  "social.reportCategoryName.inappropriate": "性的・不適切なコンテンツ",
  "social.reportCategoryName.spam": "スパム・詐欺",
  "social.reportCategoryName.cheating": "不正行為・バグの悪用",
  "social.reportCategoryName.username": "不快なユーザー名",
  "social.reportCategoryName.other": "その他",
  "social.reportDetails": "詳細(任意)",
  "social.reportDetailsPlaceholder": "何が起きたかを簡単に説明してください。",
  "social.reportChatIncluded":
    "このプレイヤーの最近のチャットメッセージが通報に含まれます。",
  "social.reportBlockHint":
    "{name}をブロックして、チャットメッセージとエモートを非表示にすることもできます。",
  "social.sending": "送信中…",
  "social.submitReport": "通報を送信",
  "social.optIn.title": "任意のゲーム内チャット",
  "social.optIn.optional":
    "ゲーム内チャットは任意です。同意すると、プレイヤーが作成したメッセージの閲覧と送信を選択したことになります。",
  "social.optIn.notMonitored":
    "メッセージはプレイヤーによって作成されたもので、ATN DEVを代表するものではありません。チャットは表示前に監視されているとは限りません。チャットが非公開または機密であるとは考えないでください。",
  "social.optIn.conduct":
    "脅迫、嫌がらせ、ヘイト、詐欺、スパム、違法行為、その他の禁止行為にチャットを使用しないでください。ATN DEVは通報を確認し、警告、チャット制限、アカウントの一時停止や停止を行う場合があります。",
  "social.optIn.sensitive":
    "パスワード、金融情報、その他の機密性の高い個人情報をチャットで共有しないでください。",
  "social.optIn.detailsBefore": "詳細は",
  "social.optIn.detailsAfter": "をご覧ください。",
  "social.optIn.agree": "同意する",
  "social.status.online": "オンライン",
  "social.status.offline": "オフライン",
  "social.status.recentlyOnline": "最近オンライン",
  "social.status.inCpuGame": "CPU戦中",
  "social.status.inGame": "対戦中",
  "social.status.spectating": "観戦中",
  "social.status.inDraftQueue": "ドラフト待機中",
  "social.status.inQueue": "待機中",
  "social.status.viewingQueue": "キューを表示中",
  "social.status.deckEditing": "デッキ編集中",
  "social.status.viewingCollection": "コレクションを表示中",
  "social.status.viewingLibrary": "ライブラリを表示中",
  "social.status.viewingAchievements": "実績を表示中",
  "social.status.viewingGlossary": "用語集を表示中",
  "social.status.adjustingSettings": "設定を調整中",
  "social.status.customizingBoard": "ボードをカスタマイズ中",
  "social.status.inMarketplace": "マーケット",
  "social.status.inSocial": "ソーシャル",
  "social.status.viewingRanking": "ランキングを表示中",
  "social.status.inWorkshop": "ワークショップ",
  "social.status.viewingCommunity": "コミュニティを表示中",
  "social.status.viewingSupport": "サポートを表示中",
  "social.status.viewingTutorials": "チュートリアルを表示中",
  "social.status.viewingSummary": "結果を表示中",
  "social.status.drafting": "ドラフト中",
  "social.status.buildingDraftDeck": "ドラフトデッキ構築中",
  "social.status.viewingDraftSummary": "ドラフト結果を表示中",
  "social.status.adventureMode": "アドベンチャーモード",
  "social.status.adventureCombatSummary": "アドベンチャー戦闘結果",
  "social.status.inAdmin": "管理画面",
  "social.status.watchingReplay": "リプレイ視聴中",
  "social.draftMode": "ドラフトモード",
  "social.bestDraftRun":
    "最高記録 勝 {wins} / 敗 {losses} / 分 {draws} · ライフ{lives} · {games}試合",
  "social.draftPool": "ドラフトプール",
  "social.noDraftRun": "完了したドラフトはありません。",
  "social.spectateGame": "試合を観戦",
  "social.blockedNotice":
    "このプレイヤーをブロックしています。チャットメッセージとエモートは非表示になり、挑戦を受けることもありません。",
  "social.noDecks": "デッキがありません。",
  "social.deckEquipmentPower": "装備 · パワー {power}",
  "social.deckAbilitiesPower": "アビリティ · パワー {power}",
  "ranking.cpuWinRatio": "CPU戦勝率",
  "ranking.humanWinRatio": "対人戦勝率",
  "ranking.cpuRecord": "CPU 勝/敗/分",
  "ranking.humanRecord": "対人 勝/敗/分",
  "ranking.prev": "前へ",
  "ranking.next": "次へ",
  "community.discordCopy": "Random's ProjectsのDiscordに参加しよう。",
  "community.joinDiscord": "Discordに参加",
  "support.contactTitle": "サポート・バグ報告のお問い合わせ",
  "support.contactCopy":
    "サポートや問題の報告はメールでお問い合わせください。",
  "support.privacyPolicy": "プライバシーポリシー",
  "support.privacyCopy":
    "収集する情報、その提供先、保存期間、アカウントとデータの削除方法をご確認ください。",
  "support.privacyTitle": "プライバシーとデータの安全性",
  "support.privacyHighlightCollect":
    "ユーザー名、ハッシュ化されたパスワード、ゲームの進行状況、IPアドレスとおおよその位置情報を収集します。メールアドレスは不要で、分析・広告SDKは使用していません。",
  "support.privacyHighlightShare":
    "個人データを販売することはありません。当社に代わって処理するのは、ホスティング、IP位置情報、メールの各プロバイダーのみです。",
  "support.privacyHighlightChat":
    "チャットはオプトイン制で、チャットを有効にしたプレイヤーに表示され、最長90日で削除されます。",
  "support.privacyHighlightDelete":
    "アカウントは「設定 > アカウント」、ウェブ、またはメールでいつでも削除できます。",
  "support.privacyRead": "プライバシーポリシーを読む",
  "support.privacyOpenWeb": "ウェブ版を開く",
  "support.privacyDeletePage": "アカウント削除ページ",
  "support.privacyPublicNote":
    "どちらのページも aeternainvicta.com/privacy と aeternainvicta.com/delete-account で公開されており、アプリなしで利用できます。プライバシーに関するお問い合わせ：{email}",
  "support.monetization": "収益化について",
  "support.monetizationCopy":
    "ゲームの開発方法、提供される広告と通貨、そしてペイ・トゥ・ウィンにしないという約束について。",
  "support.designPhilosophy": "デザイン哲学",
  "support.designPhilosophyCopy":
    "ゲームの背景にある考えについての、デザイナーからの短い手紙。",
  "support.designPhilosophyButton":
    "Aeterna Invictaの背景にある考えについて詳しく見る",
  "support.credits": "クレジットと謝辞",
  "support.creditsCopy":
    "このゲームの実現を支えてくれた友人、テストプレイヤー、そしてパブリッシャー。",
  "support.entryTitle.about": "Aeterna Invictaについて",
  "support.entryTitle.ageRating": "年齢区分とコンテンツに関する注意",
  "support.entryTitle.community": "コミュニティガイドラインと安全",
  "support.entryTitle.terms": "利用規約",
  "support.entryTitle.accountData": "アカウントとデータの削除",
  "support.entrySummary.about":
    "ゲームの概要、遊び方、そして制作者について。",
  "support.entrySummary.ageRating":
    "13歳以上のプレイヤー向けです。ファンタジー的な暴力表現と流血表現が含まれます。",
  "support.entrySummary.community":
    "安全に遊ぶ方法、禁止事項、問題の報告方法について。",
  "support.entrySummary.terms":
    "ゲーム、アカウント、ゲーム内アイテムの利用に関するルール。",
  "support.entrySummary.accountData":
    "ゲストプレイ、登録アカウント、アカウントとデータの削除方法について。",
  "support.contact.type": "種類",
  "support.contact.bug": "バグ報告",
  "support.contact.email": "メールアドレス(返信用)",
  "support.contact.bugPrompt":
    "バグが発生したとき、何をしていて何が起きていたかを説明してください。",
  "support.contact.helpPrompt": "どのようなご用件でしょうか?",
  "support.contact.send": "送信",
  "support.contact.sentTitle": "メッセージを送信しました",
  "support.contact.enterEmail": "有効なメールアドレスを入力してください。",
  "support.contact.enterMessage": "メッセージを入力してください。",
  "support.contact.sendFailed": "送信できませんでした。もう一度お試しください。",
  "support.contact.confirmation":
    "お問い合わせを完了するには、ご利用のメールサービスから準備されたメールを{email}宛に送信してください。",
  "lore.readMore": "続きを読む",
  "rulebook.title": "Aeterna Invicta ルールブック",
  "rulebook.contents": "目次",
  "rulebook.tableOfContents": "目次",
  "support.privacyLoadFailed": "プライバシーポリシーを読み込めませんでした。",
  "social.reportSubmitted":
    "通報を送信しました。Aeterna Invictaの安全維持にご協力いただきありがとうございます。",
  "social.reportFailed": "通報を送信できませんでした。",
  "social.playerFallback": "プレイヤー",
  "social.partyInviteSent": "{name}にパーティー招待を送りました。",
  "social.challengeSent": "{name}に挑戦状を送りました。",
  "social.challengeDeclined": "挑戦を断りました。",
  "social.challengeDeclinedBy": "{name}が挑戦を断りました。",
  "account.createdSignInRequired":
    "アカウントを作成しましたが、サインインが必要です。",
  "account.createdPlayingAs": "アカウントを作成しました。{name}としてプレイ中です。",
  "library.collection": "コレクション",
  "library.rulebook": "ルールブック",
  "library.glossary": "用語集",
  "library.lore": "伝承",
  "library.intro":
    "コレクションやサンプルデッキを閲覧したり、キーワードやメカニクスを調べたり、世界の伝承を読んだりできます。",
  "library.decksIntro":
    "参考として閲覧できるサンプルデッキです。カードを解放済みなら書き出して使用できます。",
  "library.missingCards": "コレクションにないカードがあります",
  "library.noDecks": "利用できるライブラリデッキはありません。",
  "library.resetDecks": "デッキをリセット",
  "library.resetDecksTitle": "デッキをリセットしますか?",
  "library.resetDecksBody":
    "保存済みのデッキをすべて、全カードを所持しているライブラリデッキに置き換えます。カスタムデッキや編集内容は失われます。",
  "library.export": "書き出し",
  "library.deckAbilityPower": "アビリティ · パワー {power}",
  "glossary.backToSearch": "検索に戻る",
  "glossary.relatedCards": "関連カード ({n})",
  "glossary.noRelatedCards": "関連カードは見つかりませんでした。",
  "glossary.search": "検索",
  "glossary.searchPlaceholder": "キーワード、用語、メカニクス",
  "glossary.noMatches": "一致する用語はありません。",
  "patchNotes.title": "パッチノート",
  "workshop.showControls": "操作を表示",
  "workshop.hideControls": "操作を隠す",
  "workshop.addCard": "カードを追加",
  "workshop.yourTurn": "自分のターン",
  "workshop.opponentTurn": "相手のターン",
  "workshop.reset": "リセット",
  "workshop.hp": "HP {hp}/{maxHp}",
  "workshop.switchAspectFor": "{name}のアスペクトを変更",
  "workshop.addCardTo": "{name}にカードを追加",
  "workshop.chooseAspect": "この席のアスペクトを選んでください。",
  "workshop.maxCopiesPerSide": "同じカードは各サイド最大{max}枚までです。",
  "gamepad.connected": "コントローラー接続済み",
  "gamepad.statusTitle": "{pad} · セレクトでナビ/画面を切り替え",
  "gamepad.ariaNav": "コントローラー接続済み、ナビバーを選択中",
  "gamepad.ariaView": "コントローラー接続済み、画面を選択中",
  "gamepad.padNav": "パッド · ナビ",
  "gamepad.padView": "パッド · 画面",
  "gamepad.connectedToast": "コントローラーが接続されました: {label}",
  "card.statusEffect": "状態効果",
  "card.empoweredPhysicalArmor": "強化：物理アーマー +{amount}（特性、装備中）",
  "card.empoweredMagicArmor": "強化：魔法アーマー +{amount}（特性、装備中）",
  "card.levels": "レベル",
  "card.level": "レベル",
  "card.cost": "コスト",
  "card.tapToReturn": "タップしてカードを戻す",
  "card.powerN": "パワー {power}",
  "card.locked": "ロック中",
  "match.board.needResource": "{attribute}が{need}必要です(所持: {have})",
  "match.board.needHealth": "体力が{need}必要です(所持: {have})",
};

export default ja;
